import React from 'react';

function Footer() {
  return (
    <footer className="tc-footer-style5">
      <div className="container">
        <div className="title">
          <img src="/home5_residence/assets/images/logo White.svg" alt="" />
        </div>
        <div className="info">
          <div className="row">
            <div className="col-lg-6">
              <h5 style={{ color: "#fff" }}> +91 78990 09244 </h5>
            </div>
            <div className="col-lg-6 mt-4 mt-lg-0 text-lg-end">
              <p style={{ color: "#fff" }}> #475, 2nd Floor, RBI Layout Main Rd, JP Nagar 7th Phase, Bengaluru - 560078 </p>
            </div>
          </div>
        </div>
        {/* <div className="foot mt-150">
          <div className="row align-items-center">
            <div className="col-lg-4">
              <a
                href="#"
                className="download-link justify-content-center text-center justify-content-lg-start text-lg-start"
              >
                <span className="icon">
                  <i className="fal fa-arrow-to-bottom"></i>
                </span>
                <span className="txt">
                  download <br /> brochure (.pdf)
                </span>
              </a>
            </div>
            <div className="col-lg-4 text-center py-4 py-lg-0">
              <a href="#"> © 2026 Mavinsky. All rights reserved. </a>
            </div>
            <div className="col-lg-4 text-center text-lg-end">
              <div className="social-icons">
                <a href="#">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="#">
                  <i className="fab fa-youtube"></i>
                </a>
                <a href="#">
                  <i className="fab fa-tiktok"></i>
                </a>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </footer>
  );
}

export default Footer;
